import $ from "cash-dom";

export default class ContactModule {

    static name = 'contact'

    constructor(node) {

        $(node).find('textarea').on('change keyup', function(e) {

            if(this.value.length) {
                $(this).addClass('filled');
            } else {
                $(this).removeClass('filled');
            }

        });
    }
}